<template>
  <div>
    <router-view name="header"></router-view>
    <router-view name="navbar"></router-view>
    <router-view></router-view>
  </div>
</template>

<script>
import { getToken } from './axios_auth'
export default {
  created () {
    // Set the correct headers for cors
    getToken.then((response) => {
      // Load the events in the store
      this.$store.dispatch('loadEvents')
      // set the path data in the store
      this.$store.dispatch('loadPaths')
      // Load the photo albums data in the store
      this.$store.dispatch('loadPhotoAlbums')
      // Load the videos in the store
      this.$store.dispatch('loadVideos')
    }).catch((response) => {
      console.log(response)
    })
  }
}
</script>

<style lang="scss">
  @import 'sass/main.scss'
</style>
